import gql from 'graphql-tag';
import { UrlAliasAllData } from '../fragments';

export default gql`
mutation createUrlAlias (
    $source_url: String!
    $target_url: String!
) {
    createUrlAlias (input: {
        source_url: $source_url,
        target_url: $target_url
    }) {
        ...UrlAliasAllData
    }
}
${UrlAliasAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createUrlAlias.ts